import CheapCruises from '@/images/cobrand/cobrand-cheap-cruises-promo.jpg'
import Cruise411 from '@/images/cobrand/cobrand-cruise411-promo.jpg'
import CruisesCom from '@/images/cobrand/cobrand-cruises-com-promo.jpg'
import CruisesOnly from '@/images/cobrand/cobrand-cruises-only-promo.jpg'
import LuxuryOnly from '@/images/cobrand/cobrand-luxury-only-promo.jpg'
import Rakuten from '@/images/cobrand/cobrand-rakuten-promo.jpg'
import RetailMeNot from '@/images/cobrand/cobrand-retailmenot-promo.jpg'
import TopCashback from '@/images/cobrand/cobrand-topcashback-promo.jpg'
import Affirm from '@/images/cobrand/cobrand-affirm-promo.jpg'
import Klarna from '@/images/cobrand/cobrand-klarna-promo.jpg'

type cobrandsType = {
  [key: string]: {
    alt: string
    src: string
  }
}
const affirm = {
  alt: 'Welcome Affirm member, thanks for choosing priceline',
  src: Affirm
}

const klarna = {
  alt: 'Welcome Klarna member, thanks for choosing priceline',
  src: Klarna
}

const cobrands: cobrandsType = {
  co46157: {
    alt: 'Welcome Rakuten member, thanks for choosing priceline',
    src: Rakuten
  },
  co2210202: {
    alt: 'Welcome RetailMeNot shopper, save on all your travel needs!',
    src: RetailMeNot
  },
  plchpcruises: {
    alt: 'CheapCruises.com Priceline Express Deal',
    src: CheapCruises
  },
  plc411: {
    alt: 'Cruise411 Priceline Express Deals',
    src: Cruise411
  },
  plcruises: {
    alt: 'Cruises Priceline Express Deals',
    src: CruisesCom
  },
  plconly: {
    alt: 'CruisesOnly Priceline Express Deal',
    src: CruisesOnly
  },
  pllux: {
    alt: 'Luxury Only Priceline Express Deal',
    src: LuxuryOnly
  },
  co5464610: {
    alt: 'Welcome TopCashback Member, earn cash back on your travel order',
    src: TopCashback
  },
  co8191141: affirm,
  co100011847: affirm,
  co100187965: affirm,
  co9252602: klarna,
  co100136872: klarna,
  co100688040: klarna
}

export default function getCobrandContent(refid: string | null) {
  return cobrands[refid?.toLowerCase() ?? '']
}
